import { AbstractControl } from '@angular/forms';
import CommonTypesHelper from '../helpers/common-types-helper';

export function ValidateGender(control: AbstractControl) {
  const validacion: boolean = CommonTypesHelper.stringHasValue(control.value);
  return validacion ? null : { whitespace: true };
}